import React, { useState, useCallback, useEffect } from "react";
import { Button } from "../ui/button";
import { signUp } from "@/services/auth";
import { useAppStore } from "@/store/app";
import { validateCPF } from "@/lib/utils";
import logoUbdo from "@/assets/img/logo-ubdo.png";
import bg2 from "@/assets/img/bg-2.png";
import spinner from "@/assets/img/spinner.png";

export default function SignUpForm() {
  const { login, logout, restoreSession } = useAppStore();

  const [username, setUsername] = useState("");
  const [telefone, setTelefone] = useState("");
  const [error, setError] = useState<any>();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      try {
        console.log(username);
        if (!username || !validateCPF(username)) {
          setError("Por favor informe um CPF válido");
          return;
        }

        setLoading(true);
        await signUp({ username, password: username, telefone });
        await login({ username, password: username });
        await restoreSession();
      } catch (err) {
        console.log(err);
      }
    },
    [username, telefone, restoreSession, login]
  );

  useEffect(() => {
    setError(null);
  }, [username]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    logout();
  }, []);

  // Função para formatar o telefone
  const formatTelefone = (value: string) => {
    return value
      .replace(/\D/g, "") // Remove tudo o que não for número
      .replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3"); // Formata como (xx) xxxxx-xxxx
  };

  return (
    <div className="w-full h-full text-secondary">
      <div className=" bg-no-repeat bg-[#F6F600] pt-[60px]">
        <img src={logoUbdo} className="w-1/3 mx-auto block mb-10" />
        <img src={bg2} className="w-full" />
      </div>
      <div className="bg-white p-28 w-full">
        <div className="mx-auto w-[65vw]">
          <h1 className="text-3xl font-bold">Acessar quiz</h1>
          {loading ? (
            <div className="py-6 text-xl font-light flex gap-2 items-center">
              <img src={spinner} className="w-16 animate-spin" />
              <span>Carregando...</span>
            </div>
          ) : null}
          {!loading ? (
            <form
              onSubmit={handleSubmit}
              className="flex flex-col items-start gap-2 mt-10"
            >
              <label htmlFor="username">Digite seu CPF</label>
              <input
                type="text"
                name="username"
                placeholder="000.000.000-00"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value.replace(/\D/g, ""))}
                className="bg-gray-100 p-3 rounded-sm border-b border-b-gray-300 w-full"
                autoComplete="off"
              />
              {!error ? (
                <p className="text-gray-400 font-light mb-4">
                  Apenas números e sem pontuação.
                </p>
              ) : null}
              {error ? (
                <p className="text-red-400 font-bold mb-4">{error}</p>
              ) : null}

              <label htmlFor="telefone">Digite seu número de telefone</label>
              <input
                type="text"
                name="telefone"
                placeholder="(61) 99999-9999"
                required
                value={telefone}
                onChange={(e) => setTelefone(formatTelefone(e.target.value))}
                className="bg-gray-100 p-3 rounded-sm border-b border-b-gray-300 w-full"
                maxLength={11}
                autoComplete="off"
              />
              <p className="text-gray-400 font-light mb-4">Apenas números.</p>

              <Button type="submit" className="text-lg p-6 uppercase mt-10">
                ENTRAR
              </Button>
            </form>
          ) : null}
        </div>
      </div>
    </div>
  );
}
